export default __webpack_public_path__ + "1681e4fa3dd8a766c68b1767c535146b.svg";